const API_BASE = process.env.REACT_APP_API_URL || '';

export async function getProgramRequirements(orgId, programId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/programs/${programId}/required-docs`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    if (response.status === 403) {
      throw new Error('You do not have permission to view program requirements');
    }
    throw new Error('Failed to fetch program requirements');
  }
  
  const data = await response.json();
  return data.requirements;
}

export async function getComplianceStatus(orgId, programId, filters = {}) {
  const params = new URLSearchParams();
  if (filters.siteId) params.append('siteId', filters.siteId);
  if (filters.assetId) params.append('assetId', filters.assetId);
  
  const queryString = params.toString();
  const url = `${API_BASE}/orgs/${orgId}/programs/${programId}/compliance-status${queryString ? '?' + queryString : ''}`;
  
  const response = await fetch(url, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch compliance status');
  }
  
  const data = await response.json();
  return data.status;
}

export async function createProgramRequirement(orgId, programId, data) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/programs/${programId}/required-docs`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-org-id': orgId
    },
    body: JSON.stringify(data)
  });
  
  if (!response.ok) {
    if (response.status === 403) {
      throw new Error('You do not have permission to create requirements');
    }
    throw new Error('Failed to create requirement');
  }
  
  const result = await response.json();
  return result.requirement;
}

export async function updateProgramRequirement(orgId, programId, requirementId, updates) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/programs/${programId}/required-docs/${requirementId}`, {
    method: 'PUT',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-org-id': orgId
    },
    body: JSON.stringify(updates)
  });
  
  if (!response.ok) {
    if (response.status === 403) {
      throw new Error('You do not have permission to update requirements');
    }
    throw new Error('Failed to update requirement');
  }
  
  const result = await response.json();
  return result.requirement;
}
